import { sensorsApi } from "./client"
import type { PaginatedResponse, Alert } from "@/types/api"

export async function fetchAlerts(options?: {
  siteSlug?: string
  active?: boolean
}): Promise<Alert[]> {
  const searchParams: Record<string, string | boolean> = {
    page_size: "5000",
    active_threshold: true,
  }
  if (options?.active !== undefined) searchParams.active = options.active
  if (options?.siteSlug) searchParams.site = options.siteSlug

  const response = await sensorsApi
    .get("api/alerts/alert-history/", { searchParams })
    .json<PaginatedResponse<Alert>>()
  return response.results
}
